import React, { useState } from 'react';
import './QualityRating.css';

const QualityRating = () => {
  const [selectedPeriod, setSelectedPeriod] = useState('7d');

  // Mock quality rating data
  const [qualityData] = useState([
    {
      phoneNumber: '+1 650 555 3333',
      phoneNumberId: '27681414235104944',
      currentRating: 'GREEN',
      previousRating: 'GREEN',
      ratingHistory: [
        { date: '2024-01-21', rating: 'GREEN' },
        { date: '2024-01-20', rating: 'GREEN' },
        { date: '2024-01-19', rating: 'GREEN' },
        { date: '2024-01-18', rating: 'YELLOW' },
        { date: '2024-01-17', rating: 'YELLOW' },
        { date: '2024-01-16', rating: 'GREEN' },
        { date: '2024-01-15', rating: 'GREEN' }
      ],
      metrics: {
        blockedRate: 0.02,
        reportedRate: 0.05,
        optOutRate: 0.01,
        messageVolume: 15420,
        deliveryRate: 99.5
      },
      issues: []
    },
    {
      phoneNumber: '+1 650 555 3334',
      phoneNumberId: '27681414235104945',
      currentRating: 'YELLOW',
      previousRating: 'GREEN',
      ratingHistory: [
        { date: '2024-01-21', rating: 'YELLOW' },
        { date: '2024-01-20', rating: 'YELLOW' },
        { date: '2024-01-19', rating: 'GREEN' },
        { date: '2024-01-18', rating: 'GREEN' },
        { date: '2024-01-17', rating: 'GREEN' },
        { date: '2024-01-16', rating: 'GREEN' },
        { date: '2024-01-15', rating: 'GREEN' }
      ],
      metrics: {
        blockedRate: 0.15,
        reportedRate: 0.25,
        optOutRate: 0.08,
        messageVolume: 3420,
        deliveryRate: 95.2
      },
      issues: [
        'High block rate detected',
        'Increased opt-out rate'
      ]
    },
    {
      phoneNumber: '+1 650 555 3335',
      phoneNumberId: '27681414235104946',
      currentRating: 'RED',
      previousRating: 'YELLOW',
      ratingHistory: [
        { date: '2024-01-21', rating: 'RED' },
        { date: '2024-01-20', rating: 'RED' },
        { date: '2024-01-19', rating: 'YELLOW' },
        { date: '2024-01-18', rating: 'YELLOW' },
        { date: '2024-01-17', rating: 'GREEN' },
        { date: '2024-01-16', rating: 'GREEN' },
        { date: '2024-01-15', rating: 'GREEN' }
      ],
      metrics: {
        blockedRate: 0.45,
        reportedRate: 0.60,
        optOutRate: 0.25,
        messageVolume: 1200,
        deliveryRate: 85.0
      },
      issues: [
        'Very high block rate',
        'High report rate',
        'Significant opt-out rate',
        'Low delivery rate'
      ]
    }
  ]);

  const getRatingBadge = (rating) => {
    const config = {
      'GREEN': { color: '#10b981', bg: '#d1fae5', label: 'High Quality' },
      'YELLOW': { color: '#f59e0b', bg: '#fef3c7', label: 'Medium Quality' },
      'RED': { color: '#ef4444', bg: '#fee2e2', label: 'Low Quality' },
      'NA': { color: '#6b7280', bg: '#f3f4f6', label: 'Not Rated' }
    };

    const ratingConfig = config[rating] || config['NA'];
    return (
      <span 
        className="rating-badge" 
        style={{ background: ratingConfig.bg, color: ratingConfig.color }}
        title={ratingConfig.label}
      >
        {rating}
      </span>
    );
  };

  const getRatingTrend = (current, previous) => {
    if (current === previous) return 'stable';
    if (current === 'GREEN' || (current === 'YELLOW' && previous === 'RED')) return 'improving';
    return 'declining';
  };

  const overallStats = {
    green: qualityData.filter(d => d.currentRating === 'GREEN').length,
    yellow: qualityData.filter(d => d.currentRating === 'YELLOW').length,
    red: qualityData.filter(d => d.currentRating === 'RED').length,
    avgBlockRate: (qualityData.reduce((sum, d) => sum + d.metrics.blockedRate, 0) / qualityData.length * 100).toFixed(2),
    avgReportRate: (qualityData.reduce((sum, d) => sum + d.metrics.reportedRate, 0) / qualityData.length * 100).toFixed(2),
    totalMessages: qualityData.reduce((sum, d) => sum + d.metrics.messageVolume, 0)
  };

  return (
    <div className="quality-rating-container">
      <div className="quality-rating-header">
        <div className="header-content">
          <h1>Quality Rating Dashboard</h1>
          <p>Monitor phone number quality ratings and messaging health</p>
        </div>
        <div className="period-selector">
          <button
            className={`period-btn ${selectedPeriod === '7d' ? 'active' : ''}`}
            onClick={() => setSelectedPeriod('7d')}
          >
            7 Days
          </button>
          <button
            className={`period-btn ${selectedPeriod === '30d' ? 'active' : ''}`}
            onClick={() => setSelectedPeriod('30d')}
          >
            30 Days
          </button>
          <button
            className={`period-btn ${selectedPeriod === '90d' ? 'active' : ''}`}
            onClick={() => setSelectedPeriod('90d')}
          >
            90 Days
          </button>
        </div>
      </div>

      <div className="quality-stats">
        <div className="stat-card green">
          <div className="stat-icon">✓</div>
          <div className="stat-content">
            <div className="stat-value">{overallStats.green}</div>
            <div className="stat-label">High Quality</div>
          </div>
        </div>
        <div className="stat-card yellow">
          <div className="stat-icon">⚠</div>
          <div className="stat-content">
            <div className="stat-value">{overallStats.yellow}</div>
            <div className="stat-label">Medium Quality</div>
          </div>
        </div>
        <div className="stat-card red">
          <div className="stat-icon">✗</div>
          <div className="stat-content">
            <div className="stat-value">{overallStats.red}</div>
            <div className="stat-label">Low Quality</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">📊</div>
          <div className="stat-content">
            <div className="stat-value">{overallStats.avgBlockRate}%</div>
            <div className="stat-label">Avg Block Rate</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">📈</div>
          <div className="stat-content">
            <div className="stat-value">{overallStats.avgReportRate}%</div>
            <div className="stat-label">Avg Report Rate</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">💬</div>
          <div className="stat-content">
            <div className="stat-value">{overallStats.totalMessages.toLocaleString()}</div>
            <div className="stat-label">Total Messages</div>
          </div>
        </div>
      </div>

      <div className="quality-details">
        {qualityData.map((data, index) => {
          const trend = getRatingTrend(data.currentRating, data.previousRating);
          return (
            <div key={index} className={`quality-card ${data.currentRating.toLowerCase()}`}>
              <div className="quality-header">
                <div className="phone-info">
                  <h3>{data.phoneNumber}</h3>
                  <span className="phone-id">ID: {data.phoneNumberId}</span>
                </div>
                <div className="rating-info">
                  <div className="current-rating">
                    {getRatingBadge(data.currentRating)}
                    {trend !== 'stable' && (
                      <span className={`trend-indicator ${trend}`}>
                        {trend === 'improving' ? '↑' : '↓'}
                      </span>
                    )}
                  </div>
                  <div className="previous-rating">
                    Previous: {getRatingBadge(data.previousRating)}
                  </div>
                </div>
              </div>

              <div className="quality-metrics">
                <div className="metrics-grid">
                  <div className="metric-item">
                    <span className="metric-label">Block Rate</span>
                    <div className="metric-value-container">
                      <span className={`metric-value ${data.metrics.blockedRate > 0.1 ? 'high' : data.metrics.blockedRate > 0.05 ? 'medium' : 'low'}`}>
                        {(data.metrics.blockedRate * 100).toFixed(2)}%
                      </span>
                      <div className="metric-bar">
                        <div 
                          className="metric-bar-fill" 
                          style={{ 
                            width: `${Math.min(data.metrics.blockedRate * 1000, 100)}%`,
                            background: data.metrics.blockedRate > 0.1 ? '#ef4444' : data.metrics.blockedRate > 0.05 ? '#f59e0b' : '#10b981'
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="metric-item">
                    <span className="metric-label">Report Rate</span>
                    <div className="metric-value-container">
                      <span className={`metric-value ${data.metrics.reportedRate > 0.2 ? 'high' : data.metrics.reportedRate > 0.1 ? 'medium' : 'low'}`}>
                        {(data.metrics.reportedRate * 100).toFixed(2)}%
                      </span>
                      <div className="metric-bar">
                        <div 
                          className="metric-bar-fill" 
                          style={{ 
                            width: `${Math.min(data.metrics.reportedRate * 500, 100)}%`,
                            background: data.metrics.reportedRate > 0.2 ? '#ef4444' : data.metrics.reportedRate > 0.1 ? '#f59e0b' : '#10b981'
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="metric-item">
                    <span className="metric-label">Opt-Out Rate</span>
                    <div className="metric-value-container">
                      <span className={`metric-value ${data.metrics.optOutRate > 0.1 ? 'high' : data.metrics.optOutRate > 0.05 ? 'medium' : 'low'}`}>
                        {(data.metrics.optOutRate * 100).toFixed(2)}%
                      </span>
                      <div className="metric-bar">
                        <div 
                          className="metric-bar-fill" 
                          style={{ 
                            width: `${Math.min(data.metrics.optOutRate * 1000, 100)}%`,
                            background: data.metrics.optOutRate > 0.1 ? '#ef4444' : data.metrics.optOutRate > 0.05 ? '#f59e0b' : '#10b981'
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="metric-item">
                    <span className="metric-label">Delivery Rate</span>
                    <div className="metric-value-container">
                      <span className={`metric-value ${data.metrics.deliveryRate > 98 ? 'low' : data.metrics.deliveryRate > 95 ? 'medium' : 'high'}`}>
                        {data.metrics.deliveryRate.toFixed(1)}%
                      </span>
                      <div className="metric-bar">
                        <div 
                          className="metric-bar-fill" 
                          style={{ 
                            width: `${data.metrics.deliveryRate}%`,
                            background: data.metrics.deliveryRate > 98 ? '#10b981' : data.metrics.deliveryRate > 95 ? '#f59e0b' : '#ef4444'
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="metric-item">
                    <span className="metric-label">Message Volume</span>
                    <span className="metric-value">{data.metrics.messageVolume.toLocaleString()}</span>
                  </div>
                </div>
              </div>

              {data.issues.length > 0 && (
                <div className="quality-issues">
                  <h4>⚠️ Issues Detected</h4>
                  <ul>
                    {data.issues.map((issue, idx) => (
                      <li key={idx}>{issue}</li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="rating-history">
                <h4>Rating History (Last 7 Days)</h4>
                <div className="history-chart">
                  {data.ratingHistory.map((entry, idx) => (
                    <div key={idx} className="history-item">
                      <div className={`history-dot ${entry.rating.toLowerCase()}`}></div>
                      <span className="history-date">{new Date(entry.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QualityRating;

